import { createAsyncThunk } from '@reduxjs/toolkit';
import { restructureErrorMessage } from '../../helpers/errorMessage';
import smeManualPaymentService from './smeManualPaymentService';

export const getSmeManualPaymentThunk = createAsyncThunk(
  'smeManualPayment/getSmeManualPayment',
  async (requestData: any, thunkAPI) => {
    try {
      return await smeManualPaymentService.getSmeManualPayment(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
